import {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import * as css from './AddEventManage.css';
import EventType from './eventType/EventType';
import Close from '../../../../component/close/Close';
import {useTranslation} from 'react-i18next';
import AccountPermission from '../../../../pages/components/accountPermission/AccountPermission';
import setGlobalState from '../../../../redux/setGlobalState';
import {useNavigate} from 'react-router-dom';
import {bounceMessage} from '../../../userMessages/UserMessage';
import {useRef} from 'react';
import {isMaster} from '../../../../functions/permission';
import {createEvent} from '../../../../redux/account/accountActions';
import {EVENT_TYPES} from '../../../../redux/event/event.type';
// import {copyUsersLive} from '../../../../redux/account/accountActions';

function AddEventManage({onClickClose, closeEvents=()=>{}}) {
    const {t} = useTranslation('layout');
    const permissionT = useTranslation('permission');
    const account = useSelector(state => state.account);
    const [show, setShow] = useState(0);
    const [loadingType, setLoadingType] = useState(null);
    const navigate = useNavigate();

    const arrayTypes = [{type: EVENT_TYPES.TICKET, text: t('ticketEvent'),permission:true},
        {type: EVENT_TYPES.AREA, text: t('areaEvent'),permission:'area'},
        {type: EVENT_TYPES.TIMETABLE, text: t('timetableEvent'),permission:'timetable'},
        {type: EVENT_TYPES.PRODUCT, text: t('product'),permission:'product'},
        {type: EVENT_TYPES.LISTING, text: t('listing'),permission:'listing'},
        ...(isMaster()?[{type: EVENT_TYPES.GIVECHAK, text: t('givechak'),permission:'givechak'}]:[]),
        {type: EVENT_TYPES.FRONTPAGE, text: t('frontpage'),permission:'home'},
        {type: EVENT_TYPES.COURSE, text: t('course'),permission:'course'},
        {type: EVENT_TYPES.HUB, text: t('hub'),permission:'hub'},
        {type: EVENT_TYPES.SCHEDULED, text: t('scheduled'),permission:'scheduled'},
        {type: EVENT_TYPES.SUBSCRIPTION, text: t('subscription'),permission: 'subscription'}
    ];

    const timer = useRef(null);

    const closeAll=()=>{
        onClickClose();
        closeEvents();
    };
    const close = (e) => {
        setShow(0);
        timer.current=setTimeout(function () {
            onClickClose(e);
        }, 400);
        if(e) {
            e.stopPropagation();
        }
    };
    const AlertNotAccount = () => {
        bounceMessage(t('alertHaveNotAccount'),'warning');
    };
    const onCreateEvent = (res) => {
        closeAll();
        if(res.eventType === 'scheduled')
            setGlobalState('ui.event.isScheduled',true);
        if(loadingType!=='course'){
            navigate(`/e/${res.eid}/event`);
            setLoadingType(null);
        }
    };
    useEffect(() => {
        setTimeout(function () {
            setShow(1);
        }, 0);
        if(!accountPid)
            AlertNotAccount();
        return ()=>{
            clearTimeout(timer.current);
        };
    }, []);

    const accountPid = useSelector(s => s.account.pid);

    const getWrapComp = (children) => {
        if(!accountPid)
            return <css.inActive onClick={AlertNotAccount} >
                {children}
            </css.inActive>;
        return children;

    };
    const onCreate = async (type) => {
        setLoadingType(type);
        if(type==='ticket' || type==='area' ){
            setGlobalState('ui.show.isOpenTickchakLoader',true);
        }
        if(type === 'course'){
            const extraPermission = 'billing';
            const billingPermissionStatus = account.permissions?.filter((item) => item.permission === extraPermission)[0]?.status;
            const suspendedStatus=account.permissions?.find((item) => item.permission === 'suspended')?.status;
            if(billingPermissionStatus === 1&&suspendedStatus===1){
                setLoadingType(null);
                setGlobalState('ui.show.isOpenEasyCourseStart',true);
                closeAll();

            }
            else {
                bounceMessage(t('noBillingPermission',{permission:`${billingPermissionStatus !== 1?permissionT.t('billing'):''} ${suspendedStatus!==1?permissionT.t('suspended'):''}`}),'warning');
                setLoadingType(null);
            }
        }
        else {
            createEvent(type).then(onCreateEvent).catch(() => { setLoadingType(null); });
        }
    };
    return (
        getWrapComp(
            <>
                <css.addEventFrame className={show && 'show'}>
                    <css.addEventTop className={'top'}><Close onClick={close} />
                        <div>{account.pid ? account.title : t('selectAccount')}</div>
                    </css.addEventTop>
                    <css.addEventTitle>{t('addEventTitle')}<br /> {t('addEventTitle1')}</css.addEventTitle>
                    <css.addEventEvents>
                        {arrayTypes.map((item, index) =>
                            <AccountPermission key={item.type} permission={item.permission}>
                                <EventType isDisabled={!!loadingType}
                                    type={item.type} key={index}
                                    status={loadingType === item.type ? 'loading' : (loadingType && 'disabled')} onClick={() => onCreate(item.type)} text={item.text} />
                            </AccountPermission>
                        )}
                    </css.addEventEvents>
                </css.addEventFrame>
            </>

        )

    );

}

export default AddEventManage;
